"use client";

import { useParams, useRouter } from "next/navigation";
import {
  WINDOW_CONF_DELETE_DRAFT,
  WINDOW_CONF_DELETE_POST,
  WINDOW_ERR_GIVE_IN_TIME,
} from "~/src/const/ui/window/window";
import { removePostedArticle } from "~/src/lib/firestore/analysis";
import { removeDraft } from "~/src/lib/firestore/draft";
import {
  QUERY_PARAM_VALUE_DRAFT,
  QUERY_PARAM_VALUE_POST,
  getMypageUrl,
  transCreateAnalysisPage,
} from "~/src/lib/ui/transition";
import { useAuthContext } from "~/src/stores/context/auth/AuthContext";
import Logo from "../../common/Logo";

export type NavbarUserAnalysisProps = {
  from: string; // 遷移元の分析記事
};

/**
 * ナビバー - 自分の投稿に対するナビバー（削除、編集UI）
 */
export default function NavbarUserAnalysis({ from }: NavbarUserAnalysisProps) {
  const router = useRouter();
  const params = useParams();
  const { user } = useAuthContext();

  // URLから記事IDを取得
  const articleId = params.id as string;

  /**
   * 編集ハンドラ
   */
  const onClickEdit = () => {
    if (!user) return;

    //------------
    // 分析作成画面へ遷移
    //------------
    transCreateAnalysisPage(router, articleId, QUERY_PARAM_VALUE_POST);
  };

  /**
   * 削除ハンドラ
   */
  const onClickDelete = async () => {
    if (!user) return;

    //------------
    // 削除確認
    //------------
    // 投稿済み記事と下書き記事で確認メッセージを出し分ける
    const confirmMessage =
      from === QUERY_PARAM_VALUE_POST ? WINDOW_CONF_DELETE_POST : WINDOW_CONF_DELETE_DRAFT;
    const result = window.confirm(confirmMessage);
    if (!result) {
      return;
    }

    try {
      //------------
      // DBから削除
      //------------
      if (from === QUERY_PARAM_VALUE_POST) {
        // 投稿済み記事
        await removePostedArticle(user.uid, articleId);
      } else if (from === QUERY_PARAM_VALUE_DRAFT) {
        // 下書き記事
        await removeDraft(user.uid, articleId);
      }

      //------------
      // マイページへ遷移
      //------------
      router.push(getMypageUrl());
    } catch (error) {
      console.error("記事の削除エラー error=", error);

      window.alert(WINDOW_ERR_GIVE_IN_TIME);
    }
  };

  return (
    <header className="sticky top-0 z-10 w-full bg-WHITE_1 px-4 py-2 shadow-sm">
      <div className="flex items-center justify-between gap-x-4 px-4">
        <Logo />
        <div className="flex items-center gap-x-4">
          <button
            type="button"
            onClick={onClickEdit}
            className="inline-flex items-center rounded-sm px-5 py-1 text-sm text-PRIMARY hover:bg-WHITE_2/80"
          >
            編集
          </button>
          <button
            type="button"
            onClick={onClickDelete}
            className="inline-flex items-center rounded-md bg-PRIMARY px-5 py-1 text-sm text-WHITE_1 hover:bg-PRIMARY/80"
          >
            削除
          </button>
        </div>
      </div>
    </header>
  );
}
